import React from 'react';
import { Helmet } from 'react-helmet';
import { Switch, Route } from 'react-router-dom';
// import Particles from 'react-particles-js';

import ThemeContext from '@thesoutherncross-uk/cassiopeia/dist/context/theme';

import AuthorisedRoute from './components/authorised-route';
import { PageNotFound } from './pages/error';
import routes from './routes';

/**
 * Application
 *
 * @returns
 */
const App = () => {
  const theme = React.useContext(ThemeContext);
  return (
    <>
      <Helmet titleTemplate="%s | The Southern Cross UK">
        <meta name="description" content="Helmet application" />
        <meta name="theme-color" content={theme.palette.primary} />
      </Helmet>

      <Switch>
        {routes.map(route =>
          route.public ? (
            <Route
              key={route.path}
              exact={route.exact || false}
              path={route.path}
              component={route.component}
            />
          ) : (
            <AuthorisedRoute
              key={route.path}
              exact={route.exact || false}
              path={route.path}
              component={route.component}
            />
          ),
        )}

        {/* NO MATCHING ROUTE FOUND */}
        <Route component={PageNotFound} />
      </Switch>
    </>
  );
};

export default App;
